import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

interface CustomDatePickerProps {
    value: Date | null
    onChange: (date: Date | null) => void
    label?: string
    error?: boolean
    helperText?: string
    fullWidth?: boolean
    /** When set, restricts selectable dates. No restriction by default. */
    minDate?: Date | null
    /** When set, restricts selectable dates. No restriction by default. */
    maxDate?: Date | null
}

export default function CustomDatePicker({
    value,
    onChange,
    label,
    error = false,
    helperText,
    fullWidth = true,
    minDate,
    maxDate
}: CustomDatePickerProps) {
    const resolvedMinDate = minDate ?? undefined;
    const resolvedMaxDate = maxDate ?? undefined;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={label}
                value={value}
                {...(resolvedMinDate != null && { minDate: resolvedMinDate })}
                {...(resolvedMaxDate != null && { maxDate: resolvedMaxDate })}
                onChange={onChange}
                slotProps={{
                    textField: {
                        fullWidth,
                        error,
                        helperText,
                        sx: {
                            '& .MuiInputBase-input': {
                                bgcolor: 'background.paper',
                                color: 'text.primary',
                            },
                            '& .MuiOutlinedInput-root': {
                                bgcolor: 'background.paper',
                            },
                            '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                                borderColor: 'black !important',
                                borderWidth: '2px',
                            },
                            '& .MuiPickersOutlinedInput-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline': {
                                borderColor: 'black !important',
                                borderWidth: '2px',
                            },
                        },
                        FormHelperTextProps: {
                            sx: {
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '0.75rem',
                            }
                        }
                    },
                    day: {
                        sx: {
                            '&.Mui-selected': {
                                backgroundColor: 'black',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'black',
                                },
                            },
                            '&.MuiPickersDay-root.Mui-selected': {
                                backgroundColor: 'black',
                                color: 'white',
                            },
                        },
                    },
                    actionBar: {
                        sx: {
                            '& .MuiButton-root': {
                                color: 'black',
                                backgroundColor: 'transparent',
                                fontWeight: 500,
                            },
                            '& .MuiButton-root.MuiButton-textPrimary': {
                                color: 'black',
                                backgroundColor: 'transparent',
                            },
                        },
                    },
                }}
            />
        </LocalizationProvider>
    )
}
